/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable react/no-unused-state */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-undef */
import React, { useContext, useEffect, useState } from 'react';
import LazyLoad from 'react-lazy-load';

import SliderComponent from '../../../modules/Slider/SliderComponent';
import MainWrapper from '../../../modules/Slider/MainWrapper';
import Hero from '../../../modules/Hero/Hero';
import { readCookie } from '../../../handleCookieData';
import './MainPage.css';

import { AuthContext } from '../../../context/AuthContext';

function MainPage(props) {
  const { authenticatedUser } = useContext(AuthContext);
  const { onlyShowPublicProjects } = props;

  // Projekt-IDs der Projekte, die im Hero angezeigt werden-->
  function chooseFromHeroProjects() {
    const projectsArray = [
      '4217', // Liebe Emmilia (2023SS)
      '4235', // Kopfkino (2023SS)
      '3650', // Psychotrop (2021SS)
      '3543', // Blind (2020WS)
      '3474', // Immersion (2020WS)
      '3448', // VR-Bending (2020WS)
      '3453', // Silvatya (2020WS)
      '3493', // Space Battles (2020WS)
      '3372', // HdM Mediathek (2020SS)
      '3374', // Alte Welten (2020SS)
      '3425', // The Lost Laugh (2020SS)
      '3099', // Zwischen Mehl und Milch (2019SS)
      '3072', // gAMe40 (2019SS)
      '3091', // GodDamn (2019SS)
    ];
    return Number(
      projectsArray[Math.floor(Math.random() * projectsArray.length)]
    );
  }

  /* Für den Slider müssen jeweils nur props für die Headline und den Ajax Query übergeben werden */

  const VERTICAL_OFFSET = 500;
  const THROTTLE = 150;

  return (
    <div>
      <div id="hero">
        <Hero projektID={chooseFromHeroProjects()} />
      </div>
      <MainWrapper>
        {readCookie('last_seen').toString().length > 1 ? (
          <SliderComponent
            big
            sliderHeadline="Könnte Dir gefallen"
            contentType={`new_resolveParamsRecommendation?nur_oeffentlich=${
              onlyShowPublicProjects ? 1 : 0
            }`}
            recentlyViewed={readCookie('last_seen')}
            userRights={authenticatedUser.auth_state}
            key={onlyShowPublicProjects}
          />
        ) : null}
        {readCookie('last_seen').toString().length > 1 ? ( // Falls es keinen Empfohlen Slider gibt, wird neue Projekte oben als BIG angezeigt
          <LazyLoad
            className="responsive"
            offsetVertical={VERTICAL_OFFSET}
            throttle={THROTTLE}
            debounce={false}
          >
            <SliderComponent
              sliderHeadline="Neu in der Mediathek" // Neuste Uploads
              contentType={`latest_added_projects?nur_oeffentlich=${
                onlyShowPublicProjects ? 1 : 0
              }`}
              userRights={authenticatedUser.auth_state}
              key={onlyShowPublicProjects}
            />
          </LazyLoad>
        ) : (
          <LazyLoad
            className="responsive"
            offsetVertical={VERTICAL_OFFSET}
            throttle={THROTTLE}
            debounce={false}
          >
            <SliderComponent
              sliderHeadline="Neu in der Mediathek" // Neuste Uploads)
              contentType={`latest_added_projects?nur_oeffentlich=${
                onlyShowPublicProjects ? 1 : 0
              }`}
              big
              userRights={authenticatedUser.auth_state}
              key={onlyShowPublicProjects}
            />
          </LazyLoad>
        )}

        {readCookie('list_cookie').toString().length > 1 ? ( // Mag ich Slider wird angezeigt wenn man etwas in der Liste hat
          <LazyLoad
            className="responsive"
            offsetVertical={VERTICAL_OFFSET}
            throttle={THROTTLE}
            debounce={false}
          >
            <SliderComponent
              sliderHeadline="Mag ich"
              contentType={`resolveParams?nur_oeffentlich=${
                onlyShowPublicProjects ? 1 : 0
              }`}
              recentlyViewed={readCookie('list_cookie')}
              userRights={authenticatedUser.auth_state}
              key={onlyShowPublicProjects}
            />
          </LazyLoad>
        ) : null}

        {/* ----------------------------------------------------------------------------- */}
        <div id="filmewrapper">
          <div className="navigation-anchor" id="film" />
          <div>
            <LazyLoad
              className="responsive"
              offsetVertical={VERTICAL_OFFSET}
              throttle={THROTTLE}
              debounce={false}
            >
              <SliderComponent
                sliderHeadline="Filme"
                contentType={`select_projekt_alle_filme?nur_oeffentlich=${
                  onlyShowPublicProjects ? 1 : 0
                }`} // Alle Filme (inklusive VFX)
                sliderAllesAnzeigenHeadline="Alle Anzeigen"
                big
                isStupro
                userRights={authenticatedUser.auth_state}
                key={onlyShowPublicProjects}
              />
            </LazyLoad>
            <LazyLoad
              className="responsive"
              offsetVertical={VERTICAL_OFFSET}
              throttle={THROTTLE}
              debounce={false}
            >
              <SliderComponent
                sliderHeadline="Neues Entdecken"
                sliderAllesAnzeigenHeadline="Alle Anzeigen" // Komplett Random wird was ausgewählt
                contentType={`select_projekt_random?nur_oeffentlich=${
                  onlyShowPublicProjects ? 1 : 0
                }`}
                big={false}
                isStupro={false}
                userRights={authenticatedUser.auth_state}
                key={onlyShowPublicProjects}
              />
            </LazyLoad>
            <LazyLoad
              className="responsive"
              offsetVertical={VERTICAL_OFFSET}
              throttle={THROTTLE}
              debounce={false}
            >
              <SliderComponent
                sliderHeadline="Filme mit Visual Effects"
                sliderAllesAnzeigenHeadline="Alle Anzeigen" // Nur VFX-Filme
                contentType={`select_projekt_vfx?nur_oeffentlich=${
                  onlyShowPublicProjects ? 1 : 0
                }`}
                big={false}
                isStupro={false}
                userRights={authenticatedUser.auth_state}
                key={onlyShowPublicProjects}
              />
            </LazyLoad>
          </div>
        </div>

        {/* ---------------------------------------------------------------------------- */}

        <div id="cawrapper">
          <div className="navigation-anchor" id="computeranimation" />
          <LazyLoad
            className="responsive"
            offsetVertical={VERTICAL_OFFSET}
            throttle={THROTTLE}
            debounce={false}
          >
            <SliderComponent
              sliderHeadline="Animationsfilme" // CA-Projekte
              sliderAllesAnzeigenHeadline="Alle Anzeigen"
              contentType={`select_projekt_ca?nur_oeffentlich=${
                onlyShowPublicProjects ? 1 : 0
              }`}
              big
              isStupro
              userRights={authenticatedUser.auth_state}
              key={onlyShowPublicProjects}
            />
          </LazyLoad>
        </div>

        <LazyLoad
          className="responsive"
          offsetVertical={VERTICAL_OFFSET}
          throttle={THROTTLE}
          debounce={false}
        >
          <SliderComponent
            sliderHeadline="Projekte nach Semester" // Aktuelle Projekte nach Semestern geordnet, nicht nach Upload
            contentType={`latest_projects?nur_oeffentlich=${
              onlyShowPublicProjects ? 1 : 0
            }`}
            userRights={authenticatedUser.auth_state}
            key={onlyShowPublicProjects}
          />
        </LazyLoad>
        {/* ---------------------------------------------------------------------------- */}
        <LazyLoad
          className="responsive"
          offsetVertical={VERTICAL_OFFSET}
          throttle={THROTTLE}
          debounce={false}
        >
          <SliderComponent
            sliderHeadline="Die Ursprünge" // Die ältesten Projekte
            contentType={`select_projekt_oldest?nur_oeffentlich=${
              onlyShowPublicProjects ? 1 : 0
            }`}
            userRights={authenticatedUser.auth_state}
            key={onlyShowPublicProjects}
          />
        </LazyLoad>

        <LazyLoad
          className="responsive"
          offsetVertical={VERTICAL_OFFSET}
          throttle={THROTTLE}
          debounce={false}
        >
          <SliderComponent
            sliderHeadline="Old but Gold" // Projekte älter als 5 Jahre random angezeigt
            contentType={`select_projekt_aelter_als_fuenf?nur_oeffentlich=${
              onlyShowPublicProjects ? 1 : 0
            }`}
            userRights={authenticatedUser.auth_state}
            key={onlyShowPublicProjects}
          />
        </LazyLoad>

        {/* ----------------------------------------------------------------------------- */}
        <div id="imwrapper">
          <div className="navigation-anchor" id="interaktivemedien" />
          <LazyLoad
            className="responsive"
            offsetVertical={VERTICAL_OFFSET}
            throttle={THROTTLE}
            debounce={false}
          >
            <SliderComponent
              sliderHeadline="Irgendwas mit Medien"
              sliderAllesAnzeigenHeadline="Alle Anzeigen"
              contentType={`select_projekt_im?nur_oeffentlich=${
                onlyShowPublicProjects ? 1 : 0
              }`}
              big
              isStupro
              userRights={authenticatedUser.auth_state}
              key={onlyShowPublicProjects}
            />
          </LazyLoad>
        </div>
        {/* ----------------------------------------------------------------------------- */}
        <div id="tonwrapper">
          <div className="navigation-anchor" id="ton" />
          <LazyLoad
            className="responsive"
            offsetVertical={VERTICAL_OFFSET}
            throttle={THROTTLE}
            debounce={false}
          >
            <SliderComponent
              sliderHeadline="Ton"
              sliderAllesAnzeigenHeadline="Alle Anzeigen"
              contentType={`select_projekt_ton?nur_oeffentlich=${
                onlyShowPublicProjects ? 1 : 0
              }`}
              big
              isStupro
              userRights={authenticatedUser.auth_state}
              key={onlyShowPublicProjects}
            />
          </LazyLoad>
        </div>
        {/* ----------------------------------------------------------------------------- */}
        <LazyLoad
          className="responsive"
          offsetVertical={VERTICAL_OFFSET}
          throttle={THROTTLE}
          debounce={false}
        >
          <SliderComponent
            sliderHeadline="All Time Shooting Stars"
            contentType={`meist_geklickt?nur_oeffentlich=${
              onlyShowPublicProjects ? 1 : 0
            }`}
            userRights={authenticatedUser.auth_state}
            key={onlyShowPublicProjects}
          />
        </LazyLoad>

        {/* ----------------------------------------------------------------------------- */}
        <div id="gameswrapper">
          <div className="navigation-anchor" id="games" />
          <LazyLoad
            className="responsive"
            offsetVertical={VERTICAL_OFFSET}
            throttle={THROTTLE}
            debounce={false}
          >
            <SliderComponent
              sliderHeadline="Games"
              sliderAllesAnzeigenHeadline="Alle Anzeigen"
              contentType={`select_projekt_game?nur_oeffentlich=${
                onlyShowPublicProjects ? 1 : 0
              }`}
              big
              isStupro
              userRights={authenticatedUser.auth_state}
              key={onlyShowPublicProjects}
            />
          </LazyLoad>
          <LazyLoad
            className="responsive"
            offsetVertical={VERTICAL_OFFSET}
            throttle={THROTTLE}
            debounce={false}
          >
            <SliderComponent
              sliderHeadline="Games mit Download"
              contentType={`select_games_with_download?nur_oeffentlich=${
                onlyShowPublicProjects ? 1 : 0
              }`}
              userRights={authenticatedUser.auth_state}
              key={onlyShowPublicProjects}
            />
          </LazyLoad>
        </div>
        {/* ----------------------------------------------------------------------------- */}
        <div id="fernsehwrapper">
          <div className="navigation-anchor" id="fernsehsendungen" />
          <LazyLoad
            className="responsive"
            offsetVertical={VERTICAL_OFFSET}
            throttle={THROTTLE}
            debounce={false}
          >
            <SliderComponent
              sliderHeadline="Fernsehsendungen"
              sliderAllesAnzeigenHeadline="Alle Anzeigen"
              contentType={`select_projekt_tv?nur_oeffentlich=${
                onlyShowPublicProjects ? 1 : 0
              }`}
              big
              isStupro
              userRights={authenticatedUser.auth_state}
              key={onlyShowPublicProjects}
            />
          </LazyLoad>
        </div>
        {/* ----------------------------------------------------------------------------- */}

        {readCookie('last_seen').toString().length > 1 ? (
          <LazyLoad
            className="responsive"
            offsetVertical={VERTICAL_OFFSET}
            throttle={THROTTLE}
            debounce={false}
          >
            <SliderComponent // Zuletzt gesehene Projekte
              sliderHeadline="Nochmal ansehen"
              contentType={`resolveParams?nur_oeffentlich=${
                onlyShowPublicProjects ? 1 : 0
              }`}
              recentlyViewed={readCookie('last_seen')}
              userRights={authenticatedUser.auth_state}
            />
          </LazyLoad>
        ) : null}
      </MainWrapper>
    </div>
  );
}

export default MainPage;
